import axios from 'axios'

export default {
    get: async function (regionId) {
        const response = await axios.get('/api/incumbent-plan', { params: { 'region-id': regionId } })
        return response.data
    }
}